// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OWcB5","type":"styles_type__3eVuh","choices":"styles_choices__ZhdNv"};